import { useContext } from 'react';
import { cn } from '@/lib/utils';
import { DesktopContext } from '@/desktop/DesktopContext';

interface LinkEmbedProps {
  url: string;
  className?: string;
  hideImage?: boolean;
}

export function LinkEmbed({ url, className, hideImage: _hideImage }: LinkEmbedProps) {
  const desktop = useContext(DesktopContext);

  let display = url;
  try {
    display = new URL(url).hostname.replace(/^www\./, '');
  } catch { /* keep raw */ }

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (desktop) {
      desktop.openNsite(url);
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        'block w-full text-left border rounded-lg px-3 py-2 hover:bg-muted/50 transition-colors text-sm',
        className,
      )}
    >
      <div className="font-medium truncate">{display}</div>
      <div className="text-xs text-muted-foreground truncate">{url}</div>
    </button>
  );
}
